<p-dialog [draggable]="false" [visible]="isDialogVisible" [closable]="false" appendTo="self">
  @if (wellheadDisabled) {
    <i class="pi pi-exclamation-circle pr-1"></i> <label>Not applicable for the outermost string or liners</label>
  }
  @if (configMissing) {
    <i class="pi pi-exclamation-circle pr-1"></i> <label>Well Configuration Missing: Please specify at least one string</label>
  }
  <br> <br>
</p-dialog>

<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">
  <div class="flex">

    <div class="w-full">
      <form [formGroup]="wellheadForm" class="m-2 space-y-2">
        <div class="flex flex-col">
          <label>Wellhead Inner Diameter</label>
          <app-validated-number-input
            [control]="wellheadInnerDiameterControl"
            [value]="wellheadInnerDiameterControl.value"
            [validation]="{ required: true, min: 0.1, max: 1000 }"
            [unit]="innerDiameterUnit"
            [unitPrecisionOverrides]="{ 'in': 3, 'cm': 3, 'mm': 3 }"
          ></app-validated-number-input>
        </div>
  
  
        <div class="flex flex-col">
          <label>Hanger Lockdown Rating</label>
          <app-validated-number-input
            [control]="hangerLockdownRatingControl"
            [value]="hangerLockdownRatingControl.value"
            [validation]="{ required: true, min: 0.1, max: 1000000000 }"
            [unit]="forceUnit"
          ></app-validated-number-input>
        </div>
      </form>
    </div>
    
  </div>
</app-tool-loader>